export const ACCOUNT_STATUS = {
  ACTIVE: 'ACTIVE',
  UNDERAGE: 'UNDERAGE',
  ALUMNI: 'ALUMNI',
  AGE_RESTRICTED: 'AGE_RESTRICTED',
};

/**
 * Resolve intern age eligibility from API eligibility payload and/or JWT claims.
 * Priority: eligibility.canApply → JWT canApply → !aboveOrUnderAge
 */
export const resolveEligibility = (eligibility, jwtClaims = {}) => {
  if (eligibility && typeof eligibility.canApply === 'boolean') {
    return {
      accountStatus: eligibility.accountStatus || (eligibility.canApply ? ACCOUNT_STATUS.ACTIVE : ACCOUNT_STATUS.AGE_RESTRICTED),
      canApply: eligibility.canApply,
    };
  }

  if (typeof jwtClaims.canApply === 'boolean') {
    return {
      accountStatus:
        jwtClaims.accountStatus || (jwtClaims.canApply ? ACCOUNT_STATUS.ACTIVE : ACCOUNT_STATUS.AGE_RESTRICTED),
      canApply: jwtClaims.canApply,
    };
  }

  const canApply = !jwtClaims.aboveOrUnderAge;
  return {
    accountStatus: canApply ? ACCOUNT_STATUS.ACTIVE : ACCOUNT_STATUS.AGE_RESTRICTED,
    canApply,
  };
};

export const getEligibilityBannerMessageKey = (accountStatus) => {
  switch (accountStatus) {
    case ACCOUNT_STATUS.ALUMNI:
      return 'eligibilityAlumniMessage';
    case ACCOUNT_STATUS.UNDERAGE:
      return 'eligibilityUnderageMessage';
    case ACCOUNT_STATUS.AGE_RESTRICTED:
      return 'eligibilityAgeRestrictedMessage';
    default:
      return null;
  }
};

export const getEligibilityAvailability = (canApply, currentAvailability) => {
  if (!canApply) return false;
  return Boolean(currentAvailability);
};
